import { autoRegisterFeature } from '@store/features/factory';

import { jotauditFeature } from './store/feature';

autoRegisterFeature(jotauditFeature);

// Store exports
export * from './store';

// Type exports
export * from './types';

// Constants exports
export * from './constants';

// Component exports
export * from './components';

// Hook exports
export * from './hooks';

// Main page export
export { EncounterAuditDetail } from './components/encounters/EncounterAuditDetail';
export { EncounterAuditsList } from './components/encounters/EncounterAuditsList';
export { NoteAuditDetail } from './components/notes/NoteAuditDetail';
export { ProviderDetail } from './components/providers/ProviderDetail';
export { JotAuditPage } from './JotAuditPage';
export { JotAuditPageWrapper } from './JotAuditPageWrapper';
export { RuleAnalyticsPage } from './RuleAnalyticsPage';

// Admin page exports
export { AdminJotAuditDashboardPage } from './AdminJotAuditDashboardPage';
export { AdminJotAuditDashboardEmbedded } from './AdminJotAuditDashboardEmbedded';
